import type { EnhancedToolResult, ToolDefinition } from '../../types';
import { Tool } from '../Tool';

import { getAllBrandKits } from 'js/src/data/brand-kits/brand-kits-selectors';

export class ListBrandKitsTool extends Tool {
    public static readonly toolName = 'list_brand_kits';

    public override getToolDefinition(): ToolDefinition {
        return {
            type: 'function',
            function: {
                name: ListBrandKitsTool.toolName,
                description: "List all of the current team's saved brand kits.",
                parameters: {
                    type: 'object',
                    properties: {},
                    required: [],
                },
            },
        };
    }

    public override getToolDisplayName(): string {
        return 'Listing brand kits';
    }

    public get statusIcon(): string {
        return 'palette';
    }

    public override async execute(): Promise<EnhancedToolResult> {
        const brandKits = getAllBrandKits(this.getState()).toJS();
        return {
            result: JSON.stringify(brandKits),
            isSuccess: true,
        };
    }
}
